import { useState, useEffect, useCallback } from "react";
import { loadCartListDetails } from "../../redux/actions";
import { useDispatch, useSelector } from 'react-redux';
import OrderSummary from "./OrderSummary";
import { useNavigate } from "react-router-dom";

const CheckOutPage = () => {
    const region     = useSelector(state => state.region.region);
    const user_data  = useSelector((state) => state?.user_data?.user_data) ?? {};
    const promocode  = localStorage.getItem("promocode") ?? '';
    const [selectedLine, setSelectedLine] = useState({});
    const navigate = useNavigate();
    const dispatch  = useDispatch();
    const localCartId = localStorage.getItem('cartIds') ? JSON.parse(localStorage.getItem('cartIds')) : '';

    const fetchCartDetails = useCallback(async () => {

        let cartIds = [];
        
        if(user_data?.shopping_carts) {
            cartIds = user_data?.shopping_carts;
        } else if(localCartId) {
            cartIds = localCartId.map(item => item.cartId);
        }
        
        const data = await loadCartListDetails(cartIds, dispatch);

        //data for payment summary
        if(data?.length > 0) {
            const transformCartData = (data) => {
                return data
                    .filter(cart => cart?.lines?.length > 0) 
                    .map(cart => ({
                        shopping_cart_id: cart?.id,
                        selected_lines: cart?.lines.map(line => line.product_variation.id),
                        selected_transferred_carts: [] 
                    }));
            };

            setSelectedLine(transformCartData(data));
        }
    });

    useEffect(() => {
        fetchCartDetails();
    }, []);

    return (
        <section className="hot-deals pt-20">
            <div className='container container-lg'>   
                <div className="section-heading">
                    <div className="d-flex align-items-center justify-content-between gap-0 w-100">
                    
                    <button
                        onClick={() => navigate(-1)}
                        className="ph ph-arrow-left animated-caret w-52 h-52 text-xl flex-center bg-main-product-50 hover-bg-main-product-50 text-white"
                    ></button>
                    
                    <h2 className="mb-0 text-blue flex-grow-1">
                        &nbsp;&nbsp;Checkout
                    </h2>
                    </div>
                </div>

                <OrderSummary 
                    user          = {user_data} 
                    region        = {region} 
                    promocode     = {promocode} 
                    selectedLines = {selectedLine}
                    localCartId   = {localCartId}
                />
            </div>        
        </section>
    )
}

export default CheckOutPage;
